import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const AIChatAgent = () => {
  const [isMinimized, setIsMinimized] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMinimized(false);
    }, 7000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (
        document.querySelector(
          'script[data-widget-id="6a36bbdb5dcabc40b5a94b83"]',
        )
      ) {
        return;
      }

      const script = document.createElement("script");
      script.src = "https://widgets.leadconnectorhq.com/loader.js";
      script.setAttribute(
        "data-resources-url",
        "https://widgets.leadconnectorhq.com/chat-widget/loader.js",
      );
      script.setAttribute("data-widget-id", "6a36bbdb5dcabc40b5a94b83");
      script.async = true;
      document.body.appendChild(script);
    }, 5000);

    const handleOpenChat = () => {
      setIsMinimized(false);
      setTimeout(() => {
        const chatWidget = document.querySelector("chat-widget");
        if (chatWidget && chatWidget.shadowRoot) {
          const button = chatWidget.shadowRoot.querySelector("button");
          if (button) (button as HTMLElement).click();
        }
      }, 100);
    };

    window.addEventListener("open-chat", handleOpenChat);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("open-chat", handleOpenChat);
    };
  }, []);

  const chatUI = (
    <>
      {isMinimized && (
        <style>
          {`
            chat-widget {
              display: none !important;
              opacity: 0 !important;
              pointer-events: none !important;
              visibility: hidden !important;
            }
          `}
        </style>
      )}

      {!isMinimized && (
        <button
          onClick={() => setIsMinimized(true)}
          className="fixed z-[2147483647] bg-slate-900 text-white rounded-full border-2 border-white flex items-center justify-center shadow-md cursor-pointer hover:bg-slate-800 transition-colors pointer-events-auto"
          style={{
            width: "28px",
            height: "28px",
            bottom: "85px",
            left: "15px",
          }}
          aria-label="Sluit chat"
        >
          <X size={16} strokeWidth={3} />
        </button>
      )}

      {isMinimized && (
        <button
          onClick={() => setIsMinimized(false)}
          className="fixed z-[2147483647] bg-[#38bdf8] text-white rounded-full flex items-center justify-center shadow-lg cursor-pointer hover:scale-110 transition-transform pointer-events-auto"
          style={{
            width: "32px",
            height: "32px",
            bottom: "20px",
            left: "20px",
          }}
          aria-label="Open chat"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
          </svg>
        </button>
      )}
    </>
  );

  return typeof document !== "undefined"
    ? createPortal(chatUI, document.body)
    : null;
};

export default AIChatAgent;
